<template>
  <div class="p-3 bg-white">
    <shared-consultation-add-custom-field
      @addCustomFieldSuccess="addCustomFieldSuccess"
    ></shared-consultation-add-custom-field>
    <div class="text-center">
      <vs-button id="addConfigurationConsultationCustomFieldButton" class="m-2" color="primary" type="filled" @click.prevent="addCustomField">{{ $t('save') }}</vs-button>
      <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancel">{{ $t('cancel') }}</vs-button>
    </div>
  </div>
</template>

<script>
import SharedConsultationAddCustomField from '@/views/Shared/Configuration/Consultation/CustomFields/Add'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.Configuration.Consultation.CustomField.Add',
  components: {
    SharedConsultationAddCustomField
  },
  methods: {
    addCustomField () {
      EventBus.$emit('addNewCustomField')
    },
    cancel () {
      this.$windowOpenerHelper.notifyOpener('reload_configuration_consultation_custom_field_table')
      window.close()
    },
    addCustomFieldSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_configuration_consultation_custom_field_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
